import { useState, useEffect, FC, useRef } from 'react'
import { useLazyQuery, useMutation } from '@apollo/client'
import moment from 'moment'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

import DownloadCsv from '../Download/DownloadCsv'
import EditAgent from './EditAgent'
import { alert, areYouSurePrompt } from '../../../utils/helper'
import plusIcon from '../../../_metronic/images/smlplus.svg'
import {
  GET_SALES_CHANNEL_AGENTS_LIST,
  DELETE_USER_AGENT,
  UPDATE_USER_STATUS,
  GET_AGENT_LEADER_LIST_FOR_AGENT,
} from '../../../utils/GraphQLAPI'
import SearchList from '../../sharedComponent/SearchList/SearchList'
import { AGENT_LIST_CONFIGS } from './AgentListUtils'
import Breadcrumbs from '../../sharedComponent/Breadcrumbs/Breadcrumbs'
import { GLOBAL_CONSTANTS } from '../../../utils/GlobalConstants'
import { CreateAgentModel } from '../TeamAdmin/SalesChannels/EditSalesChannel/CreateAgentModel'
import { formatCreateAgentInput } from '../TeamAdmin/SalesChannels/SalesChannelHelpers'


const MySwal = withReactContent(Swal)
const fetchPolicy = 'network-only'
const DashboardPage: FC = () => {
  const [agentsListApiResponse, setAgentsListApiResponse] = useState<any>([])

  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)

  const [csv, setCsv] = useState<boolean>(false)
  const [filterTempOptions, setFilterTempOptions] = useState<any>()
  const [downloadData, setDownloadData] = useState<any>([])
  const csvRef = useRef<any>(null)

  const [agentLeaderOptions, setAgentLeaderOptions] = useState<any>([])
  const [listOptions, setListOptions] = useState<any>({
    perPage: 10,
    page: 1,
    searchText: '',
    orderBy: {
      by: 'createdAt',
      order: 'DESC'
    }
  })
  const [showEditModal, setShowEditModal] = useState<any>({
    show: false,
    id: '',
    agentFirstName: '',
    agentLastName: '',
    agentEmail: '',
    agentStatus: '',
    agentLeaderName: '',
    AgentUserName: '',
  })

  // For Add Modal
  const openAddModal = (event: any, editValue: any) => {
    setShowCreateAppModal(true)
  }

  const handleAddCloseModal = () => {
    setShowCreateAppModal(false)
  }

  // List API
  const [getSalesChannelAgents, { loading: listLoading, refetch }] = useLazyQuery(
    GET_SALES_CHANNEL_AGENTS_LIST,
    {
      fetchPolicy,
      variables: listOptions,
      onCompleted: (agentData) => {
        setAgentsListApiResponse({
          ...agentData.getSalesChannelAgentsList,
          agents: agentData.getSalesChannelAgentsList.agents.map((agent: any) => ({
            ...agent,
            agentEmail: agent?.loginUsername ? "-" : agent.agentEmail,
            originalAgentEmail: agent.agentEmail,
            isDisabled: agent.isDisabled === null ? null : agent.isDisabled ? false : true,
            loginUsername: agent?.loginUsername ?? '-',
            loginPassword: agent?.loginUsername ? "********" : "-",
            isActive: agent?.isActive,
          })),
        })
      },
      onError: (err) => console.warn(err),
    }
  )

  useEffect(() => {
    getSalesChannelAgents()
  }, [refetch])

  useEffect(() => {
    getSalesChannelAgents()
  }, [listOptions])

  const [getSalesChannelAgentsCSVList, { loading: reload }] = useLazyQuery(
    GET_SALES_CHANNEL_AGENTS_LIST,
    {
      fetchPolicy,
      variables: filterTempOptions,
      onCompleted: async (agentData) => {
        const res = await agentData.getSalesChannelAgentsList.agents.map((agent: any) => {
          return {
            ...agent,
            loginUsername: agent.loginUsername ? agent.loginUsername : '-',
            agentEmail: agent.loginUsername ? "-" : agent.agentEmail,
            agentCreatedAt: moment.utc(agent.agentCreatedAt).local().format('ll, hh:mm A'),
            agentStatus: agent.agentStatus.charAt(0).toUpperCase() + agent.agentStatus.slice(1),
            isDisabled: agent?.isDisabled === null ? 'Inactive' : !!agent?.isDisabled ? "Inactive" : 'active',
            isActive: agent.isActive ? "Verified" : "Pending"
          }
        })
        setDownloadData(res)
      },
      onError: (err) => console.warn(err),
    }
  )

  //For Delete
  const [deleteAgent] = useMutation(DELETE_USER_AGENT, {
    fetchPolicy: 'network-only',
    onCompleted: () => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Agent deleted successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      refetch()
    },
    onError: (err) => alert(err.message, 'error'),
  })

  // List Download
  const csvHeaders = [
    { label: 'First Name', key: 'agentFirstName' },
    { label: 'Last Name', key: 'agentLastName' },
    { label: 'Email ID', key: 'agentEmail' },
    { label: 'User Name', key: 'loginUsername' },
    { label: '# Products Assigned', key: 'agentProductsCount' },
    { label: 'Created Date', key: 'agentCreatedAt' },
    { label: 'Rep Id', key: 'agentRepId' },
    { label: "Activation Status", key: "isActive" },
    { label: 'Active Status', key: 'isDisabled' },
    { label: 'Status', key: 'agentStatus' },

  ]

  useEffect(() => {
    const { page, perPage, ...rest } = listOptions
    setFilterTempOptions(rest)
    setCsv(false)
  }, [])

  const csvDownloadFun = async () => {
    await getSalesChannelAgentsCSVList()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  //for edit

  const handleOpenEditModal = (
    id: string,
    agentFirstName: string,
    agentLastName: string,
    agentEmail: string,
    agentStatus: string,
    agentRepId: string,
    loginUsername: string
  ) => {
    setShowEditModal({
      show: true,
      id,
      agentFirstName,
      agentLastName,
      agentEmail,
      agentStatus,
      agentRepId,
      AgentUserName: loginUsername,
    })
  }

  const [updateAgentStatus] = useMutation(UPDATE_USER_STATUS, {
    onCompleted: (data) => {
      refetch()
      alert('Agent Status updated successfully', 'success')
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })

  // agent Leader API
  const [getAgentLeaderList] = useLazyQuery(GET_AGENT_LEADER_LIST_FOR_AGENT, {
    onCompleted: (data) => setAgentLeaderOptions(data?.getAgentLeaderListForAgent),
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getAgentLeaderList({
      variables: {
        salesChannelId: '',
      },
    })
  }, [])
  //create agent handler

  const handleCreateAgentSubmit = async (
    agentValue: any,
    createAgents: any,
    uploadAgent: any,
    trackId?: string,
    salesChannelId?: string,
    createAgentsWithPassword?: any,
    activeStatus?: boolean,
    uploadAgentWithPassword?: any
  ) => {

    const agentArray = await formatCreateAgentInput(agentValue, agentLeaderOptions)
    const uploadAgentPayload = agentArray.map((agent: any) => {
      return {
        ...(activeStatus && { agentEmailID: agent?.agentEmailID }),
        agentFirstName: agent?.agentFirstName,
        agentLastName: agent?.agentLastName,
        agentLeaderCode: agent?.agentLeaderCode ? agent?.agentLeaderCode : null,
        agentRepId: agent?.agentRepId,
        ...(!activeStatus && { userName: agent?.UserName }),
        ...(!activeStatus && { password: agent?.agentPassword }),
      }
    })

    if (activeStatus) {
      await uploadAgent({
        variables: {
          isVerified: false,
          trackId,
          userData: uploadAgentPayload,
        },
      })
    }
    else {
      await uploadAgentWithPassword({
        variables: {
          isVerified: false,
          trackId,
          userData: uploadAgentPayload,
        },
      })
    }
    refetch()
  }

  return (
    <>
      <Breadcrumbs title='Agent List' subTitle='Home - Agent List' />
      <SearchList
        isSearchable={true}
        filterOptions={listOptions}
        setFilterOptions={setListOptions}
        apiData={agentsListApiResponse?.agents}
        listCount={agentsListApiResponse?.totalCount}
        listLoading={listLoading}
        listConfigs={AGENT_LIST_CONFIGS}
        isActiveApiFieldName='isDisabled'
        idFieldName='agentId'
        paginatedCount={agentsListApiResponse?.agents?.length}
        toolbar={
          <>
            <div className='m-0'>
              <DownloadCsv
                csvDownloadFun={csvDownloadFun}
                reload={reload}
                csvHeaders={csvHeaders}
                csvRef={csvRef}
                downloadData={downloadData}
                downloadFileName='Agents.csv'
              />
              <button
                className='btn btn-primary fs-6 p-3 w-142px h-43px ms-4'
                type='button'
                onClick={(e) => openAddModal(e, '')}
              >
                <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                <span>Add Agent</span>
              </button>
            </div>

            <CreateAgentModel
              show={showCreateAppModal}
              handleClose={handleAddCloseModal}
              refetchList={refetch}
              agentLeaderList={agentLeaderOptions}
              handleCreateAgentSubmit={handleCreateAgentSubmit}
            />
          </>
        }
        dropdownMenuItems={[
          {
            name: 'Edit',
            callBack: (id: string, _, apiDataValues) => {
              handleOpenEditModal(
                apiDataValues.agentId,
                apiDataValues.agentFirstName,
                apiDataValues.agentLastName,
                apiDataValues.agentEmail,
                apiDataValues.agentStatus.toLowerCase(),
                apiDataValues.agentRepId,
                apiDataValues.loginUsername,
              )
            },
          },
          {
            name: 'ACTIVATION',
            callBack: (id: string, _, apiDataValues) => {
              areYouSurePrompt(
                'Are you sure?',
                () =>
                  updateAgentStatus({
                    variables: {
                      userId: apiDataValues.agentUserId,
                      isDisabled: apiDataValues.isDisabled ? true : false,
                    },
                  }),
                () => { },
                'Yes',
                'No'
              )
            },
          },
          {
            name: 'Delete',
            callBack: (id: string, _, apiDataValues) => {
              const emailId = agentsListApiResponse?.agents.find((val: any) => val.agentId === id)
              areYouSurePrompt(
                'Are you sure?',
                () => deleteAgent({ variables: { emailId: apiDataValues?.agentEmail === '-' ? emailId?.originalAgentEmail : apiDataValues?.agentEmail } }),
                () => { },
                'Yes, delete!',
                'No'
              )
            },
            textColor: 'text-danger',
          },
        ]}
      />

      <EditAgent
        modalConfig={showEditModal}
        setShowEditModal={setShowEditModal}
        getSalesChannelAgents={getSalesChannelAgents}
        agentLeaderList={agentLeaderOptions}
      />
    </>
  )
}

const AgentList: FC = () => <DashboardPage />

export { AgentList }
